export const SettingValueValidation = (formData) => {
    const errors = {};

    // Validate each field
    if (!formData.vc_ValueName.trim()) {
        errors.vc_ValueName = 'This Field is required';
    }
    if (!formData.vc_Value.trim()) {
        errors.vc_Value = 'This Field is required';
    }
    if (!formData.SettingID === 0) {
        errors.SettingID = 'This Field is required';
    }

    return errors;
};

